/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { ClientLoginApiResponse } from '../models/client-login-api-response';
import { GenericResponse } from '../models/generic-response';
import { LoginRequest } from '../models/login-request';
import { OtpValidationRequest } from '../models/otp-validation-request';
import { ResendOtpRequest } from '../models/resend-otp-request';

/**
 * Open client Authentication/credential related Apis
 */
@Injectable({ providedIn: 'root' })
export class ClientAuthService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `clientPasswordLogin()` */
  static readonly ClientPasswordLoginPath = '/api/v1/auth/clients/login';

  /**
   * Authentication a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientPasswordLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientPasswordLogin$Response(
    params: {
      body: LoginRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClientLoginApiResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ClientAuthService.ClientPasswordLoginPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClientLoginApiResponse>;
        })
      );
  }

  /**
   * Authentication a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientPasswordLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientPasswordLogin(
    params: {
      body: LoginRequest;
    },
    context?: HttpContext
  ): Observable<ClientLoginApiResponse> {
    return this.clientPasswordLogin$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ClientLoginApiResponse>
        ): ClientLoginApiResponse => r.body
      )
    );
  }

  /** Path part for operation `clientTwoFactorLogin()` */
  static readonly ClientTwoFactorLoginPath = '/api/v1/auth/clients/two-factor';

  /**
   * Authentication a user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientTwoFactorLogin()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientTwoFactorLogin$Response(
    params: {
      body: OtpValidationRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<ClientLoginApiResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ClientAuthService.ClientTwoFactorLoginPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<ClientLoginApiResponse>;
        })
      );
  }

  /**
   * Authentication a user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientTwoFactorLogin$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientTwoFactorLogin(
    params: {
      body: OtpValidationRequest;
    },
    context?: HttpContext
  ): Observable<ClientLoginApiResponse> {
    return this.clientTwoFactorLogin$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<ClientLoginApiResponse>
        ): ClientLoginApiResponse => r.body
      )
    );
  }

  /** Path part for operation `clientResendOtp()` */
  static readonly ClientResendOtpPath = '/api/v1/auth/clients/resend-otp';

  /**
   * for resend client  two factor otp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `clientResendOtp()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientResendOtp$Response(
    params: {
      body: ResendOtpRequest;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<GenericResponse>> {
    const rb = new RequestBuilder(
      this.rootUrl,
      ClientAuthService.ClientResendOtpPath,
      'post'
    );
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http
      .request(
        rb.build({ responseType: 'json', accept: 'application/json', context })
      )
      .pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
          return r as StrictHttpResponse<GenericResponse>;
        })
      );
  }

  /**
   * for resend client  two factor otp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `clientResendOtp$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  clientResendOtp(
    params: {
      body: ResendOtpRequest;
    },
    context?: HttpContext
  ): Observable<GenericResponse> {
    return this.clientResendOtp$Response(params, context).pipe(
      map((r: StrictHttpResponse<GenericResponse>): GenericResponse => r.body)
    );
  }
}
